import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useSelectedDate } from "@/context/DateContext";

/**
 * Dropdown selector de carreras (Saratoga, fecha global). Emite race_id.
 *  props:
 *    - value: race_id number|null
 *    - onChange: (race_id) => void
 *    - date?: opcional (override); default = fecha global
 *    - includeAll?: si true, incluye option "Todas"
 */
export const RaceSelect = ({ value, onChange, date: dateOverride, includeAll = false, testid = "race-select" }) => {
    const { date } = useSelectedDate();
    const targetDate = dateOverride || date;
    const [races, setRaces] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let alive = true;
        setLoading(true);
        api.get(`/races?date=${targetDate}`)
            .then((r) => alive && setRaces(r.data || []))
            .catch(() => alive && setRaces([]))
            .finally(() => alive && setLoading(false));
        return () => {
            alive = false;
        };
    }, [targetDate]);

    return (
        <Select
            value={value != null ? String(value) : undefined}
            onValueChange={(v) => onChange(v === "__all" ? null : parseInt(v, 10))}
        >
            <SelectTrigger data-testid={testid} className="h-9 font-mono text-sm">
                <SelectValue placeholder={loading ? "Cargando…" : "Seleccionar carrera"} />
            </SelectTrigger>
            <SelectContent>
                {includeAll && (
                    <SelectItem value="__all">Todas</SelectItem>
                )}
                {races.length === 0 && !loading && (
                    <div className="px-3 py-2 text-xs text-muted-foreground">
                        Sin carreras para {targetDate}.
                    </div>
                )}
                {races.map((r) => (
                    <SelectItem key={r.race_id} value={String(r.race_id)}>
                        <span className="font-mono">
                            {r.track_id} R{r.race_number}
                        </span>
                        <span className="text-muted-foreground ml-2 text-xs">
                            {r.race_type || "—"} • {r.distance_furlongs ? `${r.distance_furlongs}f` : ""} • {r.surface || ""}
                        </span>
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
